import React, { useEffect, useState } from "react";

import { LinearProgress } from "@mui/material";
import { CarrierManagementList, CarrierSearchFilters } from "../components/Lists/CarrierManagementList";
import useAuth from "../context/AuthProvider";
import { apiClient } from "../helper/api";

export const CarrierManagement = () => {

    const { user } = useAuth();
    const token = user?.token;
    const [loading, setloading] = useState(false);
    const [InsuranceComapny, setInsuranceComapny] = useState([])
    const [sortModel, setSortModel] = useState<any>([{ field: 'name', sort: 'asc' }]);

    const fetchData = (filters?: CarrierSearchFilters) => {
        setloading(true)
        const carrierParam = (filters?.carrier ?? "").trim();
        const naicParam = (filters?.naic ?? "").trim();
        apiClient(
            `/InsuranceCompany/getAllInsuranceCompany?carrier=${encodeURIComponent(carrierParam)}&naic=${encodeURIComponent(naicParam)}&stateid=`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }
        )
            .then((res) => {
                if (!res || res.ok === false || res.status === false) {
                    setInsuranceComapny([]);
                    return;
                }
                setInsuranceComapny(Array.isArray(res.data) ? res.data : []);
            }).finally(() => {
                setloading(false)
            });
    }

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <div>
            {loading && <LinearProgress sx={{ backgroundColor: "#132D3D" }} />}
            <CarrierManagementList
                InsuranceComapnyCL={InsuranceComapny}
                fetchData={fetchData}
                sortModel={sortModel}
                setSortModel={setSortModel}
            />
        </div>
    );
}
